import(/* webpackMode: "eager" */ "/app/src/app/video-call/page.tsx");
